import React, { Component } from 'react';
import { FormGroup, Label, Input, Row, Col } from 'reactstrap';
import classnames from 'classnames';

import moment from 'moment';

class OroDobPicker extends Component {
  constructor(props) {
    super(props);
    var dob = moment().subtract(18, 'years')
    this.state = {
      dob: dob,
      year: dob.year(),
      month: dob.month(),
      day: dob.date()
    };

    this.setDate = this.setDate.bind(this);
    this.isValid = this.isValid.bind(this);
  }

  componentDidMount() {
    var dob = moment().subtract(18, 'years')
    this.setState({
      dob: dob,
      year: dob.year(),
      month: dob.month(),
      day: dob.date()
    },() => {
      this.props.onDateUpdated(this.state)
    })
  }

  isValid(selectedDate){
    var date = new Date();
    return selectedDate.isBefore(date);
  };

  setDate(field, value) {
   if (value) {
    var dob = this.state.dob;

    switch(field) {
      case 'month':
        dob.month(value);
        break;
      case 'year':
        dob.year(value);
        break;
      case 'day':
        dob.date(value)
        break;
    }

    if(!this.isValid(dob)) {
      dob = moment();
    }

    this.setState({
      dob: dob,
      month: dob.month(),
      year: dob.year(),
      day: dob.date()
    }, () => {
      this.props.onDateUpdated(this.state)
    });
   }

    // console.log(typeof date === 'string');
    // this.setState({
    //   dob: date,
    //   formattedDob: typeof date === 'string' ? date : date.format("MMMM D, YYYY")
    // }, () => {
    //   this.props.onDateUpdated(this.state)
    // });
  }

  getDaysList(numberOfDays) {
    var daysList = [];

    for(var day = 1; day <= numberOfDays; day++) {
      daysList.push(<option value={day} index={day}>{day}</option>);
    }

    return daysList;
  }

  getYearsList() {
    var yearsList = [];
    var currentYear = parseInt(moment().year());

    for (var year = 0; year < 100; year++) {
      var yearValue = currentYear - year;
      yearsList.push(<option value={yearValue} index={year}>{yearValue}</option>);
    }

    return yearsList;
  }

  render() {
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    return (
      <FormGroup className={this.props.classname}>
        <Label for="dob" 
                className={classnames('text-muted', 'font-size-tiny', { invisible: !this.state.dob })} >
                {this.props.label}
        </Label>

        <Row>
          <Col xs={12}>
            <div className="d-flex">
              <select className="custom-select border-bottom border-1 form-control" 
                    id="month" 
                    name="month" 
                    value={this.state.month} 
                    onChange={e => this.setDate('month', e.target.value)}
                    >
                      <option value="" key="none">Select Month</option>
                      {months.map((month, index) => (
                          <option value={index} key={index}>{month}</option> 
                        ))} 
                    </select>

              <select className="custom-select border-bottom border-1 form-control" 
                    id="day" 
                    name="day" 
                    value={this.state.day} 
                    onChange={e => this.setDate('day', e.target.value)}
                    >
                      <option value="" key="none">Select Date</option>
                      {
                        this.getDaysList(moment(this.state.year + '-' + (parseInt(this.state.month) + 1), "YYYY-MM").daysInMonth())
                      }
                      {/*months.map((month, index) => (
                          <option value={index} key={index}>{month}</option> 
                        ))*/} 
                    </select>

              <select className="custom-select border-bottom border-1 form-control" 
                    id="year" 
                    name="year" 
                    value={this.state.year} 
                    onChange={e => this.setDate('year', e.target.value)}
                    >
                      <option value="" key="none">Select Year</option>
                      {
                        this.getYearsList()
                      }
                      {/*months.map((month, index) => (
                          <option value={index} key={index}>{month}</option> 
                        ))*/} 
                    </select>
            </div>
          </Col>
        </Row>
      </FormGroup>
    );
  }
}

export default OroDobPicker; 